/**
 * Maison Aria — Style Quiz
 * ------------------------
 * Renders quiz steps from metaobject JSON bridge,
 * collects answers, persists to localStorage, then
 * sends customer to the style analysis page.
 *
 * localStorage key: 'ma_style_quiz'
 * Shape: { version, answers: [{step, question, choice}], completed_at }
 */

document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('style-quiz-data');
  if (!dataEl) return;

  const quizSteps = JSON.parse(dataEl.textContent);
  let currentStep = 0;
  const answers = [];

  const questionEl      = document.querySelector('.quiz-question');
  const optionsEl       = document.querySelector('.quiz-options');
  const stepIndicatorEl = document.querySelector('.quiz-step-indicator');

  /* ----------------------------------------------------------
     Render a single step
  ---------------------------------------------------------- */
  function renderStep() {
    const step = quizSteps[currentStep];
    if (!step) {
      finishQuiz();
      return;
    }

    stepIndicatorEl.textContent = `Step ${currentStep + 1} of ${quizSteps.length}`;
    questionEl.textContent = step.question;
    optionsEl.innerHTML = '';
    optionsEl.classList.remove('quiz-complete');

    step.options.forEach(option => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'quiz-card';
      card.innerHTML = `
        <img src="${option.image}" alt="${option.label}" loading="lazy">
        <span>${option.label}</span>
      `;

      card.addEventListener('click', () => {
        answers.push({
          step: step.step,
          question: step.question,
          choice: option.label
        });
        currentStep++;
        renderStep();
      });

      optionsEl.appendChild(card);
    });
  }

  /* ----------------------------------------------------------
     On completion: persist payload + show CTA to analysis page
  ---------------------------------------------------------- */
  function finishQuiz() {
    const payload = {
      version: 'v1',
      answers,
      completed_at: new Date().toISOString()
    };

    // Clear any stale analysis cache so a retake generates fresh results
    localStorage.removeItem('ma_style_analysis');
    localStorage.setItem('ma_style_quiz', JSON.stringify(payload));

    optionsEl.classList.add('quiz-complete');
    questionEl.textContent = 'Your style profile is ready';

    optionsEl.innerHTML = `
      <p class="quiz-complete-text">
        Discover your style archetype and curated edit — no account needed.
      </p>
      <a href="/pages/style-analysis" class="quiz-cta">
        See your style analysis
      </a>
    `;
  }

  renderStep();
});